import React from "react";

export const EmailCampaignsContext = React.createContext();